import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ROHistoryData } from 'src/models';
import { IStoreState } from 'src/store';
import * as acBase from 'src/store/states/GenericActionCreator';
import { AxiosError } from 'axios';
import { ViewMode } from 'src/enums';

/** Interfaces */
export interface IROHistoryState {
    allRoHistory: ROHistoryData;
}

export const initialRoHistoryData: ROHistoryData = {
    built: false,
    roHistory: [],
    nshData: {
        nshDetails: [],
        errMsg: '',
    },
};

/** Initial State */
export const initialState: IROHistoryState = {
    allRoHistory: initialRoHistoryData,
};

export const ROHistorySlice = createSlice({
    name: 'ROHistory',
    initialState: initialState as IROHistoryState,
    reducers: {
        receiveROHistory: (state, action: PayloadAction<ROHistoryData>) => {
            state.allRoHistory = action.payload;
        },
        clearROHistory: (state) => {
            state.allRoHistory = initialRoHistoryData;
        },
        requestNSH: (state, action: PayloadAction<ROHistoryData>) => {
            state.allRoHistory.nshData = action.payload.nshData;
        },
    },
});

export const {
    receiveROHistory,
    clearROHistory,
    requestNSH,
} = ROHistorySlice.actions;

export default ROHistorySlice.reducer;

export function GetROHistory() {
    return async (dispatch, getState: () => IStoreState) => {
        const apptVehVin = getState().Appointment.ApptVeh.vin;
        const specProfile = getState().Framework.specProfile;
        const custNameId = getState().Vehicles.selectedVehicle;
        const store = getState().Framework.store;
        const branch = getState().Framework.branch;
        const logId = getState().Framework.logId;
        let callingProgram = 'SVP';
        const viewMode = getState().Framework.viewMode;
        if (viewMode === ViewMode.ServiceDocs || viewMode === ViewMode.ViewServiceHist) {
            callingProgram = 'OSD';
        }
        const reqData = {
            keyVin: apptVehVin,
            profileNum: specProfile,
            custId: custNameId,
            logId: logId,
            callingProgram: callingProgram,
        };
        const response =
            await acBase.eraWebServiceCall<ROHistoryData | AxiosError>('SVPController', 'ROHistory', reqData, store, branch);
        dispatch(receiveROHistory(response));
    };
}

export function GetDocsROHistory() {
    return async (dispatch, getState: () => IStoreState) => {
        const apptVehVin = getState().Appointment.ApptVeh.vin;
        const specProfile = getState().Framework.specProfile;
        const custNameId = getState().Appointment.ApptCust.custNameId;
        const store = getState().Framework.store;
        const branch = getState().Framework.branch;
        const logId = getState().Framework.logId;
        let callingProgram = 'SVP';
        const viewMode = getState().Framework.viewMode;
        if (viewMode === ViewMode.ServiceDocs || viewMode === ViewMode.ViewServiceHist) {
            callingProgram = 'OSD';
        }
        const reqData = {
            keyVin: apptVehVin,
            profileNum: specProfile,
            custId: custNameId,
            logId: logId,
            callingProgram: callingProgram,
        };
        const response =
            await acBase.eraWebServiceCall<ROHistoryData | AxiosError>('SVPController',
                'ViewServiceHistory', reqData, store, branch);
        dispatch(receiveROHistory(response));
    };
}


export function ClearROHistory() {
    return (dispatch) => {
        dispatch(clearROHistory());
    };
}

export function RequestNSH() {
    return async (dispatch, getState: () => IStoreState) => {
        const apptVehVin = getState().Appointment.ApptVeh.vin;
        const specProfile = getState().Framework.specProfile;
        const custNameId = getState().Appointment.ApptCust.custNameId;
        const store = getState().Framework.store;
        const branch = getState().Framework.branch;
        const logId = getState().Framework.logId;
        let callingProgram = 'SVP';
        const viewMode = getState().Framework.viewMode;
        if (viewMode === ViewMode.ServiceDocs || viewMode === ViewMode.ViewServiceHist) {
            callingProgram = 'OSD';
        }
        const reqData = {
            keyVin: apptVehVin,
            custId: custNameId,
            profileNum: specProfile,
            logId: logId,
            callingProgram: callingProgram,
        };
        const response =
            await acBase.eraWebServiceCall<ROHistoryData | AxiosError>('SVPController',
                'RequestNSH', reqData, store, branch);
        dispatch(requestNSH(response));
    };
}